import React, { useContext, useEffect, useState } from "react";
import Chart from "react-apexcharts"
import { LineChart,Line,XAxis,YAxis,Tooltip,ResponsiveContainer,CartesianGrid,Area,AreaChart, PieChart, Pie, Legend, Cell, BarChart, Bar } from "recharts";
import ContentPage from "../Content";
import SwalTopEnd from "../../utils/swal_top_end";
import Swal from "sweetalert2";
import axios from "axios";
import BaseUrl from "../../utils/BaseUrl";
import * as XLSX from 'xlsx';
import moment from "moment";
import separateNumber from "../../utils/separateur";
import ExportExcel from "../../utils/ExcelExport";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../utils/User_check";
import can from "../../utils/Can";


// Couleurs pour les segments du graphique
const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];

const data = [
  { month: "Jan", balance: 100 },
  { month: "Feb", balance: 120 },
  { month: "Mar", balance: 110 },
  { month: "Apr", balance: 130 },
  { month: "May", balance: 140 },
  { month: "Jun", balance: 150 },
  { month: "Jul", balance: 160 },
  { month: "Aug", balance: 150 },
  { month: "Sep", balance: 155 },
  { month: "Oct", balance: 145 },
  { month: "Nov", balance: 150 },
  { month: "Dec", balance: 5 },
];

const databar = [
  { name: "BASSAM", value: 45710500 },
  { name: "ASSINIE", value: 6130000 },
  { name: "BONOUA", value: 33848000 },
  { name: "ABOISSO", value: 18335000 },
  { name: "NZIKRO", value: 6619000 },
  { name: "EHANIA", value: 5165000 },
  { name: "MAFERE", value: 3365000 },
  { name: "NOE", value: 1225000 },
  { name: "ADIAKE", value: 3206000 },
  { name: "AYAME", value: 37485300 },
  { name: "ANYAMA", value: 24750000 },
  { name: "AGBOVILLE", value: 47740000 },
  { name: "ALEPE", value: 8762000 },
];

const dataheb = [
  { day: "Lun", AIRTIME: 130000,BUNDLE: 250000,CASHBACK:45000 },
  { day: "Mar", AIRTIME: 100000,BUNDLE: 120000,CASHBACK:29000 },
  { day: "Mer", AIRTIME: 52000,BUNDLE: 75000,CASHBACK:47500 },
  { day: "Jeu", AIRTIME: 123000,BUNDLE: 100000,CASHBACK: 76000 },
  { day: "Ven", AIRTIME: 150000,BUNDLE: 340000,CASHBACK:120000 },
  { day: "Sam", AIRTIME: 300000,BUNDLE: 55000,CASHBACK: 50000 },
  { day: "Dim", AIRTIME: 20000,BUNDLE: 139000,CASHBACK: 50000 }

];

const fullData = [
  { date: "2024-01-01", balance: 100 },
  { date: "2024-01-15", balance: 120 },
  { date: "2024-02-01", balance: 110 },
  { date: "2024-03-01", balance: 130 },
  { date: "2024-04-01", balance: 140 },
  { date: "2024-05-01", balance: 150 },
  { date: "2024-06-01", balance: 160 },
  { date: "2024-07-01", balance: 170 },
  { date: "2024-08-01", balance: 150 },
  { date: "2024-09-01", balance: 155 },
  { date: "2024-10-01", balance: 145 },
  { date: "2024-11-01", balance: 150 },
  { date: "2024-12-01", balance: 155 },
];

const fullData2 = [
  { date: "2024-01-01", balance1: 100, balance2: 90, balance3: 110 },
  { date: "2024-01-15", balance1: 120, balance2: 95, balance3: 115 },
  { date: "2024-02-01", balance1: 110, balance2: 92, balance3: 108 },
  { date: "2024-03-01", balance1: 130, balance2: 98, balance3: 120 },
  { date: "2024-04-01", balance1: 140, balance2: 105, balance3: 125 },
  { date: "2024-05-01", balance1: 150, balance2: 110, balance3: 130 },
  { date: "2024-06-01", balance1: 160, balance2: 115, balance3: 135 },
  { date: "2024-07-01", balance1: 170, balance2: 120, balance3: 140 },
  { date: "2024-08-01", balance1: 150, balance2: 115, balance3: 130 },
  { date: "2024-09-01", balance1: 155, balance2: 118, balance3: 133 },
  { date: "2024-10-01", balance1: 145, balance2: 112, balance3: 128 },
  { date: "2024-11-01", balance1: 150, balance2: 116, balance3: 132 },
  { date: "2024-12-01", balance1: 155, balance2: 120, balance3: 135 },
];
const url = BaseUrl();
function MomoHomePage(){
  const {user,role, permissions} = useContext(UserContext);
  const navigate = useNavigate();

        const [filteredData, setFilteredData] = useState(fullData2);
        const [excelData, setExcelData] = useState(null);
        const [excelFile, setExcelFile] = useState(null);
        const [excel, setExcel] = useState(null);
        const [loading,setLoading] = useState(false);
        const [dateCapture,setDateCapture] = useState('');
        const [dateDebut,setDateBut] = useState(null);
        const [dateFin,setDateFin] = useState(null);
      
      
        const [TotalApproDay,setTotatlApproDay] = useState(0)
        const [TotalAirtime,setTotalAirtime] = useState(0)
        const [TotalBundle,setTotalBundle] = useState(0);
        const [NbreCashin,setNbreCashin] = useState(0);
        const [NbreCashout,setNbreCashout] = useState(0);
        const [TotalCashBack,setTotalCashBack] = useState(0);
        const [approCash,setApproCash] = useState(0);
        const [approCredit,setApproCredit] = useState(0);
        const [tauxAppro,setTauxAppro] = useState(0);
        const [tauxVisite,setTauxVisite] = useState(0);
        const [totalVisite,setTotalVisite] = useState(0);
        const [totalAppro,setTotalAppro] = useState(0);
        const [dataSecteurAppro,setDataSecteurAppro] = useState([]);
        const [dataSecteurOut,setDataSecteursOut] = useState([]);
        const [dataSecteurEvd,setDataSecteurEvd] = useState([]);
        const [recapCommercials,setRecapCommercials] = useState([]);
        const [topPos,setTopPos] = useState([]);

          const [venteSerie,setVenteSerie] = useState([]);
          const [venteSerieOut,setVenteSerieOut] = useState([]);
          const [loading2,setLoading2] = useState(false);

        // Fonction pour filtrer les données en fonction de la période sélectionnée
        const handleFilter = (period) => {
          const now = new Date("2024-12-01"); // Exemple : dernière date de la période
          let filtered;
      
          if (period === "week") {
            const oneWeekAgo = new Date(now);
            oneWeekAgo.setDate(now.getDate() - 7);
            filtered = fullData.filter((d) => new Date(d.date) >= oneWeekAgo);
          } else if (period === "month") {
            const oneMonthAgo = new Date(now);
            oneMonthAgo.setMonth(now.getMonth() - 1);
            filtered = fullData.filter((d) => new Date(d.date) >= oneMonthAgo);
          } else if (period === "6months") {
            const sixMonthsAgo = new Date(now);
            sixMonthsAgo.setMonth(now.getMonth() - 6);
            filtered = fullData.filter((d) => new Date(d.date) >= sixMonthsAgo);
          } else if (period === "year") {
            const oneYearAgo = new Date(now);
            oneYearAgo.setFullYear(now.getFullYear() - 1);
            filtered = fullData.filter((d) => new Date(d.date) >= oneYearAgo);
          } else {
            filtered = fullData; // Tous les données par défaut
          }
      
          setFilteredData(filtered);
        };
      
        const buttonStyle = {
          padding: "10px 20px",
          backgroundColor: "#333",
          color: "#fff",
          border: "1px solid #555",
          borderRadius: "5px",
          cursor: "pointer",
        };
      
        const stateStatut = {
                
          series: [23, 11, 54, 72, 12],
          options: {
            chart: {
              width: 380,
              type: 'bar',
            },
            colors: ['#77B6EA', '#545454','#ff61f7','#00CCCB', '#E9967A'],
            labels: ["Apple", "Mango", "Banana", "Papaya", "Orange"],
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: 'bottom'
                }
              }
            }]
          },
        
        
        };
      
        const datapie = [
          { name: "CASH IN (%)", value: TotalAirtime *100/TotalApproDay },
          { name: "CASH OUT (%)", value: TotalBundle*100/TotalApproDay },
          // { name: "CASH BACK", value: TotalCashBack },
        ];
      
        useEffect(()=>{
          if(user && permissions && !can(permissions,'TABLEAU DE BORD MOMO')){
              navigate('/page-no-found');
          }
      },[user]);

        useEffect(()=>{
          exeCuteAllFunction();
        },[]);
      
        const fetchDataDashboard = async () => {
        
            const date_debut = dateDebut == null ? moment().format('YYYY-MM-DD') : dateDebut;
            const date_fin = dateFin == null ? moment().format('YYYY-MM-DD') : dateFin;
        
            console.log(dateFin);
        
            try {
        
        
                setLoading(true);
                // Remplacez par l'URL réelle de votre API
                const response = await axios.post(url.base+'/dashboard-momo-stats',{date_debut:date_debut,date_fin:date_fin},{
                    headers:{
                        'Content-Type':'application/json',
                        "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                        
                    }});
                const data = response.data;
                setTotatlApproDay(data.totalMomo);
                setTotalAirtime(data.totalCashin);
                setTotalBundle(data.totalCashout);
                setNbreCashin(data.NbreCashin);
                setNbreCashout(data.NbreCashout);
                // setApproCash(data.approCash);
                // setApproCredit(data.approCredit);
                // setTauxAppro(data.tauxAppro);
                // setTauxVisite(data.tauxVisite);
                setRecapCommercials(data.commercialTab);
                // setTotalAppro(data.totalPdvAppro);
                // setTotalVisite(data.totalPdvVisite);
                setTopPos(data.posTab);
        
                // const formattedData1 = Object.entries(data.maxSecteur).map(([name, value]) => ({ name, value }));
                const formattedData2 = Object.entries(data.maxSecteurEvd).map(([name, value]) => ({ name, value }));
                const formattedData3 = Object.entries(data.secteurMomoOuts).map(([name, value]) => ({ name, value }));
        
        
                setDataSecteurAppro(formattedData2);
                setDataSecteursOut(formattedData3);
                // setDataSecteurEvd(formattedData2);
        
                setLoading(false);
                window.$("#exampleModalFiltre").modal('hide')
            } catch (err) {
                setLoading(false);
            }
        };

        const fetchDataDashboard5 = async () => {

          setVenteSerie([]);
          try {
            // setLoading3(true);
              const response4 = await axios.get(url.base+'/stat_vente_momo_by_year',{
                  headers:{
                      'Content-Type':'application/json',
                      "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                      
                  }});
                  // setLoading3(true);
              const data4 = response4.data;  
              const labelMoisArr = Object.keys(data4?.labels).map(key => data4?.labels[key]);
        
              const transformedData = labelMoisArr.map((month, index) => ({
                month: month,
                cashin:data4.venteSerieIn[month]  || 0,
                cashout:data4.venteSerieOut[month]  || 0,
              }));


              setVenteSerie(transformedData);

          } catch (err) {
            // setLoading2(false);
          }
        };
        
        const open_import_template_modal=()=> {
            window.$("#exampleModalCenteContrat").modal('show');
        }
      
      const handleFile=(e)=>{
        let fileTypes = ['application/vnd.ms-excel','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','text/csv'];
        let selectedFile = e.target.files[0];
        if(selectedFile){
          if(selectedFile && fileTypes.includes(selectedFile.type)){
            let reader = new FileReader();
            reader.readAsArrayBuffer(selectedFile);
            reader.onload=(e)=>{
              setExcelFile(e.target.result);
              setExcel(selectedFile);
            }
          }
          else{
            SwalTopEnd({icon:"error",title:"S'il vous plait selectionné uniquement un fichier excel"});
            setExcelFile(null);
            window.$("#file_excel").val("");
          }
        }
        else{
          console.log('Please select your file');
        }
      }
      
      const validateColumns = (data) => {
        if (data.length > 0) {
            const keys = Object.keys(data[0]);
            return !(keys.includes('MSISDN_NSK')) || !(keys.includes('MT_CASH_IN')) || !(keys.includes('MT_CASH_OUT'))|| !(keys.includes('MSISDN_COMMERCIAL'))|| !(keys.includes('NOM_COMMERCIAL'));
        }
        return true;
      };
      
      const submitForm=async(e)=>{
        e.preventDefault();
        // console.log(commentaire)
        if(dateCapture !=="" ){
              const _formData = new FormData();        
              
              if(excel !== null){
      
                const workbook = XLSX.read(excelFile,{type: 'buffer'});
                const worksheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[worksheetName];
                const data = XLSX.utils.sheet_to_json(worksheet);
      
                if(data.length > 0)
                {   
                  // console.log(data)
                    if(validateColumns(data)){
                      setLoading(false);
                        SwalTopEnd({icon:"error",title:"Le fichier ne correspond pas au model"});
                        return;
                    }
      
                    const currentTimeInSeconds = Math.floor(new Date().getTime() / 1000);
                    const originalExtension = excel.name.split('.').pop();
                    const newFileName = `${currentTimeInSeconds}_excel_.${originalExtension}`;
                    const file = new File([excel], newFileName, { type: excel.type });
                    
                    _formData.append("file",file);
                    _formData.append("capture_date",dateCapture);
      
                    // console.log(_formData);
                    setLoading(true);
                  
                    try {
                        axios.post(`${url.base}/import-momo-file`,_formData,
                    {
                        headers:{
                            'Content-Type':'multipart/form-data',
                            "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                            
                        },
                        //  credentials:'include'
                    }
                    ).then((resp)=>{          
                        setLoading(false);
      
                        if(resp.data.code === 405){
                          Swal.fire({
                            title: "Attention! cette donnée existe",
                            text: "Cette action va supprimer les données du "+dateCapture+".",
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: "Oui, écraser !",
                            cancelButtonText: "Non, conserver !"
                          }).then((result) => {
                            if (result.isConfirmed) {
                              submitFormTrash();
                            }
                          });
                        }else{
                          setExcelFile(null);
                          window.$("#file_excel").val("");
                          window.$("#datecapture").val("");
                          setDateCapture("");
                          window.$("#exampleModalCenteContrat").modal('hide');
                          fetchDataDashboard();
          
                          Swal.fire({
                              title: 'Cette opération peut prendre quelques minutes...',
                              html: `<b style="color:green">Le fichier est en cours de traitement, un mail vous sera envoyé une fois le traitement terminé</b>`,
                              icon: 'warning'
                            })
          
                        }
                        
                        // navigate('/stock-materiels');
                    
                        
                    }).catch((error)=>{
                      if(error.status == 500){
                        SwalTopEnd({icon:"error",title:"Une erreur est subvenue"});
                      }
                        setLoading(false);
            
                    })
                    } catch (error) {
                        console.log(error);
                        setLoading(false);
                    } 
                }else{
                  setLoading(false);
                    SwalTopEnd({icon:"error",title:"Le fichier est vide"});
                }
                
              }
      
             
        }else{
          setLoading(false);
          if(dateCapture == ""){SwalTopEnd({icon:"error",title:"La date est obligatoire"})}
        } 
      
      
      }
      
      const submitFormTrash=async()=>{
        // e.preventDefault();
        // console.log(commentaire)

        if(dateCapture !=="" ){
          setLoading(true);
              const _formData = new FormData();        
              
              if(excel !== null){
      
                const workbook = XLSX.read(excelFile,{type: 'buffer'});
                const worksheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[worksheetName];
                const data = XLSX.utils.sheet_to_json(worksheet);
      
                if(data.length > 0)
                { 
                  // console.log(data)
                    if(validateColumns(data)){
                        SwalTopEnd({icon:"error",title:"Le fichier ne correspond pas au model"});
                        return;
                    }
      
                    const currentTimeInSeconds = Math.floor(new Date().getTime() / 1000);
                    const originalExtension = excel.name.split('.').pop();
                    const newFileName = `${currentTimeInSeconds}_excel_.${originalExtension}`;
                    const file = new File([excel], newFileName, { type: excel.type });
                    
                    _formData.append("file",file);
                    _formData.append("capture_date",dateCapture);
      
                    console.log(_formData);
        
                   
                    try {
                        axios.post(`${url.base}/import-momo-delete-file`,_formData,
                    {
                        headers:{
                            'Content-Type':'multipart/form-data',
                            "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                            
                        },
                        //  credentials:'include'
                    }
                    ).then((resp)=>{          
                        setLoading(false);
      
                     
                          setExcelFile(null);
                          window.$("#file_excel").val("");
                          window.$("#datecapture").val("");
                          setDateCapture("");
                          window.$("#exampleModalCenteContrat").modal('hide');
                          fetchDataDashboard();
                          
          
                          Swal.fire({
                            title: 'Cette opération peut prendre quelques minutes...',
                            html: `<b style="color:green">Le fichier est en cours de traitement, un mail vous sera envoyé une fois le traitement terminé</b>`,
                            icon: 'warning'
                          });
  
                    }).catch((error)=>{
                      if(error.status == 500){
                        SwalTopEnd({icon:"error",title:"Une erreur est subvenue"});
                      }
                        setLoading(false);
            
                    })
                    } catch (error) {
                        console.log(error);
                        setLoading(false);
                    } 
                }else{
                  setLoading(false);
                    SwalTopEnd({icon:"error",title:"Le fichier est vide"});
                }
                
              }
      
             
        }else{
          setLoading(false);
          if(dateCapture == ""){SwalTopEnd({icon:"error",title:"La date est obligatoire"})}
        } 
      
      
      }
      
      const sortedData = recapCommercials.sort((a, b) => b.MomoTotal - a.MomoTotal);
      
      const open_filtre_template_modal=()=> {
        window.$("#exampleModalFiltre").modal('show');
      }
      
      const filtre_periode_data=async(e)=>{
        e.preventDefault();
      
        setTotatlApproDay(0);
        setTotalAirtime(0);
        setTotalBundle(0);
        setTotalCashBack(0);
        setRecapCommercials([]);
        setDataSecteurAppro([]);
        setDataSecteurEvd([]);
        setTotalAppro(0);
        setTotalVisite(0);
        setTopPos([]);
        setApproCash(0);
        setApproCredit(0);
        setTauxAppro(0);
        setTauxVisite(0);
      
        await fetchDataDashboard();
      }
      
      const today_data_fetch=()=>{
        setDateBut(null);
        setDateFin(null);
        setTotatlApproDay(0);
        setTotalAirtime(0);
        setTotalBundle(0);
        setTotalCashBack(0);
        setRecapCommercials([]);
        setDataSecteurAppro([]);
        setDataSecteurEvd([]);
      
        
        window.location.reload();
      }

      const exeCuteAllFunction=async()=> {
        await fetchDataDashboard();
        await fetchDataDashboard5();
      
        // window.$("#exampleModalFiltre").modal('hide');
      }
          return (
              <>
                  <ContentPage>
                  <div class="page-header flex-wrap">
                    <div class="header-left">
                      <button class="btn btn-primary mb-2 mb-md-0 mr-2" onClick={()=>open_import_template_modal()}> Importer le fichier Momo </button>
                      <button type="button" class="btn btn-outline-primary mb-2 mb-md-0" onClick={()=>today_data_fetch()}> Actualiser </button>
                    </div>
                    <div class="header-right d-flex flex-wrap mt-md-2 mt-lg-0">
                      <div class="d-flex align-items-center">
                        <a href="#">
                          <p class="m-0 pr-3">RAPPORT MOMO</p>
                        </a>
                        <a class="pl-3 mr-4" href="#">
                          <p class="m-0 text-danger">{ dateFin ==null ? moment().format('Do MMMM') : `${moment(dateDebut).format('Do MMMM')} au ${moment(dateFin).format('Do MMMM')}`}</p>
                        </a>
                      </div>
                      <button type="button" class="btn btn-primary mt-2 mt-sm-0 btn-icon-text" onClick={()=>open_filtre_template_modal()}>
                        <i class="mdi mdi-plus-circle"></i> Effectuer Un Filtre </button>
                    </div>
                  </div>
      
                  <div class="row">
                    <div class="col-sm-4 stretch-card grid-margin">
                      <div class="card">
                        <div class="card-body">
                          <div class="d-flex justify-content-between">
                            <div class="card-title"> TOTAL MOMO  <small class="d-block text-muted">{ dateFin ==null ? moment().format('Do MMMM') : `${moment(dateDebut).format('Do MMMM')} au ${moment(dateFin).format('Do MMMM')}`}</small>
                            </div>
                            
                          </div>
                          <h3 class="font-weight-bold mb-0 text-success"> 
                            {!loading ? separateNumber(TotalApproDay)  :
                              <div class="spinner-grow" style={{"width": "3rem", "height": "3rem"}} role="status">
                                <span class="visually-hidden"></span>
                              </div>
                            } FCFA
                          
                          </h3>
                          <span class="text-muted font-13">CASH IN/CASH OUT</span>
                      
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4 stretch-card grid-margin">
                      <div class="card">
                        <div class="card-body">
                          <div class="d-flex justify-content-between">
                            <div class="card-title"> TOTAL CASH IN
                              <small class="d-block text-muted">{ dateFin ==null ? moment().format('Do MMMM') : `${moment(dateDebut).format('Do MMMM')} au ${moment(dateFin).format('Do MMMM')}`}</small>
                            </div>
                          
                          </div>
                          <h3 class="font-weight-bold mb-0 text-danger"> 
                          {!loading ? separateNumber(TotalAirtime)  :
                              <div class="spinner-grow" style={{"width": "3rem", "height": "3rem"}} role="status">
                                <span class="visually-hidden"></span>
                              </div>
                            } FCFA
                          </h3>
                          <span class="text-muted font-13">Somme des Cash in</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4 stretch-card grid-margin">
                      <div class="card">
                        <div class="card-body">
                          <div class="d-flex justify-content-between">
                            <div class="card-title"> TOTAL CASH OUT
                              <small class="d-block text-muted">{ dateFin ==null ? moment().format('Do MMMM') : `${moment(dateDebut).format('Do MMMM')} au ${moment(dateFin).format('Do MMMM')}`}</small>
                            </div>
                           
                          </div>
                          <h3 class={totalAppro >= 100 ? "font-weight-bold mb-0 text-success" : "font-weight-bold mb-0 text-danger"}> 
                          {!loading ? separateNumber(TotalBundle)   :
                              <div class="spinner-grow" style={{"width": "3rem", "height": "3rem"}} role="status">
                                <span class="visually-hidden"></span>
                              </div>
                            } 
                       
                          </h3>
                          <span class="text-muted font-13">
                            Somme Cash out
                          </span>
                         
                        </div>
                      </div>
                    </div>
                  </div> 

                  <div class="row">
              <div class="col-sm-6 stretch-card grid-margin">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex justify-content-between">
                      <div class="card-title"> NOMBRE DE TRANSACTION CASH IN  <small class="d-block text-muted">{ dateFin ==null ? moment().format('Do MMMM') : `${moment(dateDebut).format('Do MMMM')} au ${moment(dateFin).format('Do MMMM')}`}</small>
                      </div>
                    
                    </div>
                    <h3 class="font-weight-bold mb-0 text-danger"> 
                      {!loading ? separateNumber(NbreCashin)  :
                        <div class="spinner-grow" style={{"width": "3rem", "height": "3rem"}} role="status">
                          <span class="visually-hidden"></span>
                        </div>
                      } 
                    
                       {/* <span class="text-success h5">4,5%<i class="mdi mdi-arrow-up"></i></span> */}
                    </h3>
                    {/* <span class="text-muted font-13">Somme des approvisionnements</span> */}
                    {/* <div class="line-chart-wrapper">
                      <canvas id="linechart" height="80"></canvas>
                    </div> */}
                  </div>
                </div>
              </div>
              <div class="col-sm-6 stretch-card grid-margin">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex justify-content-between">
                      <div class="card-title"> NOMBRE DE TRANSACTION CASH OUT
                        <small class="d-block text-muted">{ dateFin ==null ? moment().format('Do MMMM') : `${moment(dateDebut).format('Do MMMM')} au ${moment(dateFin).format('Do MMMM')}`}</small>
                      </div>
                     
                    </div>
                    <h3 class="font-weight-bold mb-0 text-success"> 
                    {!loading ? separateNumber(NbreCashout)  :
                        <div class="spinner-grow" style={{"width": "3rem", "height": "3rem"}} role="status">
                          <span class="visually-hidden"></span>
                        </div>
                      } 
                      {/* <span class="text-success h5">0.20%<i class="mdi mdi-arrow-up"></i></span> */}
                    </h3>
                    {/* <span class="text-muted font-13">Somme des ventes effectuées par les POS</span> */}
                    {/* <div class="bar-chart-wrapper">
                      <canvas id="barchart" height="80"></canvas>
                    </div> */}
                  </div>
                </div>
              </div>
            </div> 
       

      
                  <div class="row">
                    
                    <div class="col-xl-12 stretch-card grid-margin">
                      <div class="card">
                        <div class="card-body pb-0">
                          <h4 class="card-title">STATISTIQUE DES VENTES MOMO DU { dateFin ==null ? moment().format('Do MMMM') : `${moment(dateDebut).format('Do MMMM')} au ${moment(dateFin).format('Do MMMM')}`}</h4>
                        </div>
                        <div class="card-body p-0">
                        
      
                        {!loading ? 
                          <PieChart width={1000} height={400}>
                            <Pie
                              data={datapie}
                              dataKey="value"
                              nameKey="name"
                              cx="50%"
                              cy="50%"
                              outerRadius={120}
                              fill="#8884d8"
                              label
                            >
                              {COLORS.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                              ))}
                            </Pie>
                            <Tooltip />
                            <Legend />
                        </PieChart>
                         :
                          <div class="spinner-grow text-center" style={{"width": "3rem", "height": "3rem"}} role="status">
                            <span class="visually-hidden"></span>
                          </div>
                        }
               
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-sm-12 stretch-card grid-margin">
                      <div class="card ">
                      <div class="card-body">
                      <h4 class="card-title">STATISTIQUE DES VENTES CASH IN PAR SECTEURS DU { dateFin ==null ? moment().format('Do MMMM') : `${moment(dateDebut).format('Do MMMM')} au ${moment(dateFin).format('Do MMMM')}`}</h4>
                        <div class="row">
                        {!loading ? 
                        <ResponsiveContainer width="100%" height={300}>
                          <BarChart data={dataSecteurAppro} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip />
                            <Bar dataKey="value" fill="#FF8042" />
                          </BarChart>
                        </ResponsiveContainer>
                        :
                        <div class="spinner-grow text-center" style={{"width": "3rem", "height": "3rem"}} role="status">
                          <span class="visually-hidden"></span>
                        </div>
                      }
                        </div>
                      </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-sm-12 stretch-card grid-margin">
                      <div class="card ">
                      <div class="card-body">
                      <h4 class="card-title">STATISTIQUE DES VENTES CASH OUT PAR SECTEURS DU { dateFin ==null ? moment().format('Do MMMM') : `${moment(dateDebut).format('Do MMMM')} au ${moment(dateFin).format('Do MMMM')}`}</h4>
                        <div class="row">
                        {!loading ? 
                        <ResponsiveContainer width="100%" height={300}>
                          <BarChart data={dataSecteurOut} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip />
                            <Bar dataKey="value" fill="#00C49F" />
                          </BarChart>
                        </ResponsiveContainer>
                        :
                        <div class="spinner-grow text-center" style={{"width": "3rem", "height": "3rem"}} role="status">
                          <span class="visually-hidden"></span>
                        </div>
                      }
                        </div>
                      </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                      <div class="col-xl-12 stretch-card grid-margin">
                        <div class="card">
                          <div class="card-body">
                            <div class="d-flex justify-content-between flex-wrap">
                              <div>
                                <div class="card-title mb-0">TOP 10 DES VENDEURS MOMO { dateFin ==null ? moment().format('Do MMMM') : `${moment(dateDebut).format('Do MMMM')} au ${moment(dateFin).format('Do MMMM')}`}</div>
                                <ExportExcel excelData={topPos} filename={"TOP VENDEURS MOMO/POS"}  title={"Télécharger"} color={'btn-success'}/>
                              </div>
                              <div>
                                <div class="d-flex flex-wrap pt-2 justify-content-between sales-header-right">
                   
                                </div>
                              </div>
                            </div>
                            {/* <p class="text-muted font-13 mt-2 mt-sm-0"> Total vente de la semaine en cours
                            </p> */}
                            <div class="flot-chart-wrapper">
      
                            <div class="table-responsive">
                            <table class="table table-striped">
                              <thead> 
                                <tr>
                                  <th>NOM DU PDV</th>
                                  <th>NUMERO</th>
                                  <th>NBRE CASH IN</th>
                                  <th>NBRE CASH OUT</th>
                                  <th>VENTE CASH IN</th>
                                  <th>VENTE CASH OUT</th>
                                  <th className="text-center">TOTAL VENDU</th>
                                  <th className="text-center">COMMERCIAL</th>
                                </tr>
                              </thead>
                              <tbody>
                              {topPos?.map((pos, index) => (
                                <tr key={index}>
                                  <td class="py-1">
                                    <img src="../../../assets/images/dashboard/img_3.jpg" alt="image"/>
                                    {pos.NomPDV}
                                  </td>
                                  <td>{pos.MSISDN_NSK}</td>                        
                                  <td className="text-center">{pos.nbreCashIN}</td>                        
                                  <td className="text-center">{pos.nbreCashOut}</td>                        
                                  <td className="text-center">{separateNumber(pos.CashIN)}</td>                        
                                  <td className="text-center">{separateNumber(pos.CashOut)}</td>                        
                                  <td className="text-center">
                                      <b className="text-danger">{separateNumber(pos.total) }</b>
                                  </td>   
                                  <td className={pos.NOM_COMMERCIAL == "AUCUN COMMERCIAL AFFECTE" ? "text-center" : "text-center font-weight-bold"}>
                                  {pos.NOM_COMMERCIAL == "AUCUN COMMERCIAL AFFECTE" ? "" : pos.NOM_COMMERCIAL}
                                  </td>                          
                                  {/* <td className="text-center"> <b className={vente.EvdTotal*100/vente.ObjectifEvd > 99 ? "text-success" : "text-danger"}>{(vente.EvdTotal*100/vente.ObjectifEvd).toFixed(2)} %</b> </td> */}
                                </tr>
                              ))}
                              </tbody>
                            </table>
                          </div>
                         
                            </div>
                          </div>
                        </div>
                      </div>
                    
                  </div>

                  <div class="row">
                      <div class="col-xl-12 stretch-card grid-margin">
                        <div class="card">
                          <div class="card-body">
                            <div class="d-flex justify-content-between flex-wrap">
                              <div>
                                <div class="card-title mb-0">EVOLUTION DES VENTES CASHIN ET CASHOUT DE L'ANNEE {moment().format('Y')}</div>
                                {/* <h3 class="font-weight-bold mb-0 text-success">{separateNumber(TotalAirtime+TotalBundle+TotalCashBack)} FCFA</h3> */}
                              </div>
                              <div>
                                <div class="d-flex flex-wrap pt-2 justify-content-between sales-header-right">
                                  <div class="d-flex mr-5">
                                    <button type="button" class="btn btn-social-icon btn-outline-sales">
                                      <i class="mdi mdi-inbox-arrow-down"></i>
                                    </button>
                                    {/* <div class="pl-2">
                                      <h4 class="mb-0 font-weight-semibold head-count"> {separateNumber(objectifEvd)} FCFA</h4>
                                      <span class="font-10 font-weight-semibold text-muted">OBJECTIF EVD</span>
                                    </div> */}
                                  </div>
                                    {/*<div class="d-flex mr-3 mt-2 mt-sm-0">
                                    <button type="button" class="btn btn-social-icon btn-outline-sales profit">
                                      <i class="mdi mdi-cash text-info"></i>
                                    </button>
                                    <div class="pl-2">
                                      <h4 class="mb-0 font-weight-semibold head-count"> 1.079.000 </h4>
                                      <span class="font-10 font-weight-semibold text-muted">TOTAL BUNDLE</span>
                                    </div>
                                  </div> */}
                                  {/* <div class="d-flex mr-3 mt-2 mt-sm-0">
                                    <button type="button" class="btn btn-social-icon btn-outline-sales profit">
                                      <i class="mdi mdi-cash text-info"></i>
                                    </button>
                                    <div class="pl-2">
                                      <h4 class="mb-0 font-weight-semibold head-count"> {((TotalAirtime+TotalBundle+TotalCashBack)*100/objectifEvd).toFixed(2) ??0}%</h4>
                                      <span class="font-10 font-weight-semibold text-muted">POURCENTAGE</span>
                                    </div>
                                  </div> */}
                                </div>
                              </div>
                            </div>
                            <p class="text-muted font-13 mt-2 mt-sm-0"> 
                            </p>
                            <div class="flot-chart-wrapper">
      
                            
                            <div style={{ backgroundColor: "#1e1e2f", padding: "30px", borderRadius: "10px" }}>
                                  <ResponsiveContainer width="100%" height={250}>
                                  <AreaChart data={venteSerie} margin={{ top: 10, right: 50, left: 50, bottom: 0 }}>
                                    <defs>
                                      <linearGradient id="colorBalance1" x1="0" y1="0" >
                                        <stop offset="0%" stopColor="#00C49F" stopOpacity={0.8} />
                                        <stop offset="100%" stopColor="#00C49F" stopOpacity={0} />
                                      </linearGradient>
                                      <linearGradient id="colorBalance2" x1="0" y1="0" x2="0" y2="1">
                                        <stop offset="0%" stopColor="#3399FF" stopOpacity={0.8} />
                                        <stop offset="100%" stopColor="#3399FF" stopOpacity={0} />
                                      </linearGradient>
                                      <linearGradient id="colorBalance3" x1="0" y1="0" x2="0" y2="1">
                                        <stop offset="0%" stopColor="#FF9933" stopOpacity={0.8} />
                                        <stop offset="100%" stopColor="#FF9933" stopOpacity={0} />
                                      </linearGradient>
                                    </defs>
                                    <CartesianGrid strokeDasharray="3 3" stroke="#3c3c3c" />
                                    <XAxis dataKey="month" tick={{ fill: "#ccc" }} />
                                    <YAxis tick={{ fill: "#ccc" }} />
                                    <Tooltip
                                      contentStyle={{
                                        backgroundColor: "#333",
                                        border: "none",
                                        color: "#fff",
                                      }}
                                    />
                                    <Legend />
                                    <Area
                                      type="monotone"
                                      dataKey="cashin"
                                      stroke="#FF9933"
                                      fill="url(#colorBalance3)"
                                      strokeWidth={2}
                                    />

                                    <Area
                                      type="monotone"
                                      dataKey="cashout"
                                      stroke="#00C49F"
                                      fill="url(#colorBalance1)"
                                      strokeWidth={2}
                                    />
                              
                                  </AreaChart>
                        
                                  </ResponsiveContainer>
                            </div>
      
                            </div>
                          </div>
                        </div>
                      </div>
                    
                  </div>
                  {/* <div class="row">
                      <div class="col-xl-12 stretch-card grid-margin">
                        <div class="card">
                          <div class="card-body">
                            <div class="d-flex justify-content-between flex-wrap">
                              <div>
                                <div class="card-title mb-0">RECAPITULATIF MOMO DES COMMERCIAUX DU { dateFin ==null ? moment().format('Do MMMM') : `${moment(dateDebut).format('Do MMMM')} au ${moment(dateFin).format('Do MMMM')}`}</div>
                                <ExportExcel excelData={recapCommercials} filename={"LISTE DES VENTES MOMO COMMERCIAUX"}  title={"Télécharger"} color={'btn-success'}/>
                              </div>
                              <div>
                                <div class="d-flex flex-wrap pt-2 justify-content-between sales-header-right">
                                </div>
                              </div>
                            </div>
                     
                            <div class="flot-chart-wrapper">
      
                            <div class="table-responsive">
                            <table class="table table-striped">
                              <thead> 
                                <tr>
                                  <th>COMMERCIAL</th>
                                  <th>NUMERO</th>
                                  <th>SECTEUR</th>
                                  <th  className="text-center">OBJECTIF  CASHIN</th>
                                  <th  className="text-center">OBJECTIF CASHOUT</th>
                                  <th>TOTAL CASHIN</th>
                                  <th>TOTAL CASHOUT</th>
                                  <th>% CASHIN</th>
                                  <th>% CASHOUT</th>
                                </tr>
                              </thead>
                              <tbody>
                              {sortedData.map((vente, index) => (
                                <tr key={index}>
                                  <td class="py-1">
                                    <img src="../../../assets/images/faces-clipart/pic-1.png" alt="image"/>
                                    {vente.NomCommercial}
                                  </td>
                                  <td>
                                  {vente.NumeroMarchand}
                                  </td>
                                  <td>
                                    {vente.NomSecteur}
                                  </td>
                                  <td className="text-center">
                                    <b className="text-success">{separateNumber(vente.ObjectifCashin)}</b>
                                  </td>
                                  <td className="text-center">
                                    <b className="text-success">{separateNumber(vente.ObjectifCashOut)}</b>
                                  </td>
                                  <td className="text-center">
                                      <b>{separateNumber(vente.MT_CASH_IN) }</b>
                                  </td>    
                                  <td className="text-center">
                                      <b>{separateNumber(vente.MT_CASH_OUT) }</b>
                                  </td>                          
                                  <td className="text-center"> <b className={vente.MT_CASH_IN*100/vente.ObjectifCashin > 99 ? "text-success" : "text-danger"}>{(vente.MT_CASH_IN*100/vente.ObjectifCashin).toFixed(2)} %</b> </td>
                                  <td className="text-center"> <b className={vente.MT_CASH_OUT*100/vente.ObjectifCashOut > 99 ? "text-success" : "text-danger"}>{(vente.MT_CASH_OUT*100/vente.ObjectifCashOut).toFixed(2)} %</b> </td>
                           
                                </tr>
                              ))}
                              </tbody>
                            </table>
                          </div>
                         
                            </div>
                          </div>
                        </div>
                      </div>
                    
                  </div> */}
      
                 
      
                <div class="modal fade" id="exampleModalCenteContrat" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                          <div class="modal-dialog modal-md" role="document">
                              <form class="modal-content" onSubmit={submitForm}>
                                  <div class="modal-header">
                                  <h5 class="modal-title" id="exampleModalCenterTitle">Importer un template excel</h5>
                                  <button type="button" class="btn-close text-danger" onClick={()=>window.$("#exampleModalCenteContrat").modal('hide')}>
                                      <span aria-hidden="true"></span>
                                  </button>
                                  </div>
                                  <div class="modal-body">
                                      <div className="row">
                                          <div class="mb-3 col-md-12">
                                                  <label class="form-label" for="textInput">Capture date</label>
                                                  <input type="date" className="form-control" id='datecapture'  onChange={(e)=>setDateCapture(e.target.value)}/>
                                          </div>  
                                          <div className="mb-3 col-md-12 col-12">
                                              <label className="form-label">Uploader le fichier</label>
                                              <input type="file" className="form-control" required onChange={handleFile} id="file_excel"/>
                                          </div>
                                      </div>
                                          
                                  </div>
                                  <div class="modal-footer">
                                      <button type="button" class="btn btn-secondary" onClick={()=>window.$("#exampleModalCenteContrat").modal('hide')}>Fermer</button>
                                      <button type="submit" class={!loading ? "btn btn-primary" : "btn btn-primary disabled"}>{!loading ? "Enregister" : "Enregistrement en cours ..."}</button>
                                  </div>
                              </form>
                          </div>
                  </div>
      
                  <div class="modal fade" id="exampleModalFiltre"  tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                          <div class="modal-dialog modal-md" role="document">
                              <form class="modal-content" onSubmit={filtre_periode_data}>
                                  <div class="modal-header">
                                  <h5 class="modal-title" id="exampleModalCenterTitle">Recherche periodique</h5>
                                  <button type="button" class="btn-close" onClick={()=>window.$("#exampleModalFiltre").modal('hide')}>
                                  </button>
                                  </div>
                                  <div class="modal-body">
                                      <div className="row">
                                          <div class="mb-3 col-md-12">
                                                  <label class="form-label" for="textInput">Date debut</label>
                                                  <input type="date" className="form-control"   onChange={(e)=>setDateBut(e.target.value)}/>
                                          </div>  
                                          <div class="mb-3 col-md-12">
                                                  <label class="form-label" for="textInput">Date Fin</label>
                                                  <input type="date" className="form-control"   onChange={(e)=>setDateFin(e.target.value)}/>
                                          </div> 
                                      </div> 
                                          
                                  </div>
                                  <div class="modal-footer">
                                  {!loading && <button type="submit" class="btn btn-primary" onClick={()=>window.$("#exampleModalFiltre").modal('hide')}>Lancer la recherche</button>}
                                      {loading && 
                                      <button type="button" class= "btn btn-primary disabled form-control">Chargement en cours  <div class="text-center">
                                        <div class="spinner-border p-2" role="status">
                                        </div>
                                      </div>
                                      </button> 
                                      }
                                  </div>
                              </form>
                          </div>
                  </div>
                  </ContentPage>
              </>
          )
}
export default MomoHomePage;

